import { render, staticRenderFns } from "./header-body.vue?vue&type=template&id=58e676bc&"
import script from "./header-body.vue?vue&type=script&lang=js&"
export * from "./header-body.vue?vue&type=script&lang=js&"
import style0 from "./header-body.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports